export default __webpack_public_path__ + "static/media/RTC_REC_MASS_UPLOAD.62f6f0ee.svg";